module.exports = __webpack_public_path__ + "img/diannao-xiazai.9b6e5012.png";